<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div
  style="height: 100%; max-width: 100%; overflow-y: auto; overflow-x: hidden"
>
  <div class="row m-0 mt-1">
    <div class="col-md-12 mt-2" style="margin: 0 -18px">
      <div
        id="carouselExampleControls"
        class="carousel slide"
        data-interval="false"
        data-wrap="false"
      >
        <div class="carousel-item active" *ngIf="customerData.length > 0">
          <div class="row m-0">
            <div
              class="col-md-3 p-1"
              *ngFor="let item of customerData.slice(0, 4); let i = index"
              (click)="OnClickFiQuestions(item)"
            >
              <div
                class="card"
                style="cursor: pointer"
                [ngClass]="{ active: item.CustomerId === CustomerId }"
              >
                <div class="card-body p-2">
                  <div class="row m-0 mb-3 align-items-center">
                    <div class="col-md-3 p-0">
                      <img
                        style="height: 45px; width: 45px"
                        src="{{ customerProfileBaseUrl }}{{
                          item.CustomerId
                        }}/{{ item.ProfilePic }}"
                        class="user-img rounded-circle img-thumbnail"
                        alt=""
                        onerror="this.onerror=null;this.src='assets/images/default-user.png';"
                      />
                    </div>
                    <div class="col-md-9 p-0">
                      <h6 class="col-md-12 mb-2 fs-12">{{ item.Customer }}</h6>
                      <p class="col-md-12 card-subtitle fs-12 text-muted">
                        {{
                          item.CustomerType == "Hirer"
                            ? "Borrower"
                            : item.CustomerType
                        }}
                      </p>
                      <div class="row m-0">
                        <div class="col-md-12">
                          <B>Status</B> : {{ item.FI_Status }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="customerData">
          <div class="carousel-item" *ngIf="customerData.length > 4">
            <div class="row m-0">
              <div
                class="col-md-3 p-1"
                *ngFor="let item of customerData.slice(4, 8); let i = index"
                (click)="OnClickFiQuestions(item)"
              >
                <div
                  class="card"
                  style="cursor: pointer"
                  [ngClass]="{ active: item.CustomerId === CustomerId }"
                >
                  <div class="card-body p-2">
                    <div class="row m-0 mb-3 align-items-center">
                      <div class="col-md-3 p-0">
                        <img
                          style="height: 45px; width: 45px"
                          src="{{ customerProfileBaseUrl }}{{
                            item.CustomerId
                          }}/{{ item.ProfilePic }}"
                          class="user-img rounded-circle img-thumbnail"
                          alt=""
                          onerror="this.onerror=null;this.src='assets/images/default-user.png';"
                        />
                      </div>
                      <div class="col-md-9 p-0">
                        <h6 class="col-md-12 mb-2 fs-12">
                          {{ item.Customer }}
                        </h6>
                        <p class="col-md-12 card-subtitle fs-12 text-muted">
                          {{
                            item.CustomerType == "Hirer"
                              ? "Borrower"
                              : item.CustomerType
                          }}
                        </p>
                        <div class="row m-0">
                          <div class="col-md-12">
                            <B>Status</B> : {{ item.FI_Status }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item" *ngIf="customerData.length > 8">
            <div class="row m-0">
              <div
                class="col-md-3 p-1"
                *ngFor="let item of customerData.slice(8, 12); let i = index"
                (click)="OnClickFiQuestions(item)"
              >
                <div
                  class="card"
                  style="cursor: pointer"
                  [ngClass]="{ active: item.CustomerId === CustomerId }"
                >
                  <div class="card-body p-2">
                    <div class="row m-0 mb-3 align-items-center">
                      <div class="col-md-3 p-0">
                        <img
                          style="height: 45px; width: 45px"
                          src="{{ customerProfileBaseUrl }}{{
                            item.CustomerId
                          }}/{{ item.ProfilePic }}"
                          class="user-img rounded-circle img-thumbnail"
                          alt=""
                          onerror="this.onerror=null;this.src='assets/images/default-user.png';"
                        />
                      </div>
                      <div class="col-md-9 p-0">
                        <h6 class="col-md-12 mb-2 fs-12">
                          {{ item.Customer }}
                        </h6>
                        <p class="col-md-12 card-subtitle fs-12 text-muted">
                          {{
                            item.CustomerType == "Hirer"
                              ? "Borrower"
                              : item.CustomerType
                          }}
                        </p>
                        <div class="row m-0">
                          <div class="col-md-12">
                            <B>Status</B> : {{ item.FI_Status }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <a
          class="carousel-control-prev ml-2"
          href="#carouselExampleControls"
          role="button"
          style="width: auto; color: #000; font-size: 24px"
          data-slide="prev"
          *ngIf="customerData.length > 4"
        >
          <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleControls"
          role="button"
          style="width: auto; color: #000; font-size: 24px"
          data-slide="next"
          *ngIf="customerData.length > 4"
        >
          <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>

  <form
    #f="ngForm"
    (ngSubmit)="onSaveCustomerFIAnswer()"
    novalidate
    *ngIf="ShowDiv"
    class="formborder"
  >
    <div class="row m-0 mt-2 h-b">
      <div class="col-md-1 pl-1"><b>#</b></div>
      <div class="col-md-3 pl-1"><b>Question</b></div>
      <div class="col-md-3 pl-1"><b>Question (Hindi)</b></div>
      <div class="col-md-5 pl-1"><b>Response</b></div>
    </div>
    <div
      class="row m-0 mt-2"
      *ngFor="let question of questionData; let i = index"
    >
      <div class="col-md-1">{{ i + 1 }}</div>
      <div class="col-md-3">{{ question.Question }}</div>
      <div class="col-md-3 pl-1">{{ question.Question_Hindi }}</div>
      <div class="col-md-5 pl-1">
        <ng-container *ngIf="question.QuestionType == 'Boolean'">
          <div class="form-check form-check-inline">
            <input
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio1"
              class="form-check-input"
              #refQR="ngModel"
              [(ngModel)]="question.FIAnswer"
              required
              value="true"
              [disabled]="IsDisabled"
              [ngClass]="{
                'is-invalid': f.submitted && refQR.invalid,
                'alert-warning':
                  refQR.invalid &&
                  (refQR.dirty || refQR.touched || refQR.untouched)
              }"
            />
            <label class="form-check-label" for="inlineRadio1">Yes</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio2"
              class="form-check-input"
              #refQR="ngModel"
              [(ngModel)]="question.FIAnswer"
              required
              value="false"
              [disabled]="IsDisabled"
              [ngClass]="{
                'is-invalid': f.submitted && refQR.invalid,
                'alert-warning':
                  refQR.invalid &&
                  (refQR.dirty || refQR.touched || refQR.untouched)
              }"
            />
            <label class="form-check-label" for="inlineRadio2">No</label>
          </div>
        </ng-container>

        <ng-container *ngIf="question.QuestionType == 'Selection'">
          <span> </span>
          <select
            name="QS{{ i }}"
            id="QS{{ i }}"
            #refQS="ngModel"
            class="form-control input-text-css"
            required
            [(ngModel)]="question.FIAnswer"
            [disabled]="IsDisabled"
            [ngClass]="{
              'is-invalid': f.submitted && refQS.invalid,
              'alert-warning':
                refQS.invalid &&
                (refQS.dirty || refQS.touched || refQS.untouched)
            }"
          >
            <option value="" [selected]="question.FIAnswer === ''">
              Select
            </option>
            <ng-container *ngFor="let option of question.questionOptionData">
              <option [value]="option">{{ option }}</option>
            </ng-container>
          </select>
        </ng-container>

        <ng-container *ngIf="question.QuestionType == 'Multi-Selection'">
          <span> </span>
          <select
            multiple
            name="QMS{{ i }}"
            id="QMS{{ i }}"
            #refQMS="ngModel"
            class="form-control input-text-css"
            required
            [(ngModel)]="question.FIAnswer"
            [disabled]="IsDisabled"
            [ngClass]="{
              'is-invalid': f.submitted && refQMS.invalid,
              'alert-warning':
                refQMS.invalid &&
                (refQMS.dirty || refQMS.touched || refQMS.untouched)
            }"
          >
            <ng-container *ngFor="let option of question.questionOptionData">
              <option [value]="option">{{ option }}</option>
            </ng-container>
          </select>
        </ng-container>

        <ng-container *ngIf="question.QuestionType == 'Integer'">
          <span></span>
          <input
            required
            type="number"
            #refQI="ngModel"
            name="QI{{ i }}"
            id="QI{{ i }}"
            [disabled]="IsDisabled"
            class="form-control input-text-css"
            [(ngModel)]="question.FIAnswer"
            placeholder="Your Answer"
            [ngClass]="{
              'is-invalid': f.submitted && refQI.invalid,
              'alert-warning':
                refQI.invalid &&
                (refQI.dirty || refQI.touched || refQI.untouched)
            }"
          />
        </ng-container>

        <ng-container *ngIf="question.QuestionType == 'Text'">
          <span></span>
          <textarea
            required
            rows="2"
            #refQT="ngModel"
            name="QT{{ i }}"
            id="QT{{ i }}"
            [disabled]="IsDisabled"
            class="form-control input-text-css"
            [(ngModel)]="question.FIAnswer"
            placeholder="Your Answer"
            [ngClass]="{
              'is-invalid': f.submitted && refQT.invalid,
              'alert-warning':
                refQT.invalid &&
                (refQT.dirty || refQT.touched || refQT.untouched)
            }"
          ></textarea>
        </ng-container>

        <ng-container
          *ngIf="question.QuestionType == 'Upload'"
          [disabled]="IsDisabled"
        >
          <i
            class="fa fa-upload"
            *ngIf="!question.FIAnswer"
            (click)="docFile.click()"
            aria-hidden="true"
          ></i>
          <ng-container *ngIf="question.FIAnswer">
            <a
              href="{{ docBaseUrl }}{{ loanSummary.ApplicationNo }}/{{
                question.FIAnswer
              }}"
              target="_blank"
            >
              <i class="fa fa-file-pdf mr-2 fs-16" aria-hidden="true"></i
              >{{ question.FIAnswer }}
            </a>
            <!-- <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i>{{question.FIAnswer}} -->
            <i
              class="fa fa-times ml-2"
              aria-hidden="true"
              style="cursor: pointer"
              (click)="removeFile(question, docFile)"
            ></i>
          </ng-container>
          <input
            #docFile
            type="file"
            [multiple]="false"
            accept="application/pdf,application/vnd.ms-excel"
            (change)="fileChangeListener(question, docFile.files)"
            style="display: none"
          />
        </ng-container>
      </div>
    </div>

    <hr />
    <div class="row m-0">
      <div class="col-md-4 p-1">
        <span class="required-lable">Recommendation</span>
        <div *ngIf="!IsEdit; else editModeRecommendation">
          <select
            name="Recommendation"
            id="Recommendation"
            #refRecommendation="ngModel"
            [(ngModel)]="Recommendation"
            [ngClass]="{
              'is-invalid': f.submitted && refRecommendation.invalid,
              'alert-warning':
                refRecommendation.invalid &&
                (refRecommendation.dirty ||
                  refRecommendation.touched ||
                  refRecommendation.untouched)
            }"
            class="form-control input-text-css"
            required
          >
            <option value="">Select Recommendation</option>
            <option value="Positive">Positive</option>
            <option value="Negative">Negative</option>
            <option value="Average">Average</option>
            <option value="Below Average">Below Average</option>
            <option value="Not Conducted">Not Conducted</option>
          </select>
        </div>
        <ng-template #editModeRecommendation>
          <div>
            <span class="form-control input-text-css">{{
              Recommendation
            }}</span>
          </div>
        </ng-template>
      </div>

      <div class="col-md-4 p-1">
        <span>FI Done By</span>
        <div *ngIf="!IsEdit; else editModeFIDoneBy">
          <select
            name="FI_DoneBy"
            id="FI_DoneBy"
            [(ngModel)]="FI_DoneBy"
            #refFI_DoneBy="ngModel"
            [ngClass]="{
              'is-invalid': f.submitted && refFI_DoneBy.invalid,
              'alert-warning':
                refFI_DoneBy.invalid &&
                (refFI_DoneBy.dirty ||
                  refFI_DoneBy.touched ||
                  refFI_DoneBy.untouched)
            }"
            class="form-control input-text-css"
            required
          >
            <option
              *ngFor="let collection of CollectionExecutiveData"
              [value]="collection.EmpId"
            >
              {{ collection.Emp_FirstName }}
            </option>
          </select>
        </div>
        <ng-template #editModeFIDoneBy>
          <span class="form-control input-text-css">
            {{ FI_DoneByName }}
          </span>
        </ng-template>
      </div>

      <div class="col-md-4 p-1">
        <span>FI Done On</span>
        <div *ngIf="!IsEdit; else editModeFIDoneOn" class="datepicker_feild">
          <input
            [matDatepicker]="picker"
            dateConvert
            placeholder="DD/MM/YYYY"
            name="FI_DoneOn"
            [(ngModel)]="FI_DoneOn"
            required
            id="FI_DoneOn"
            #refFI_DoneOn="ngModel"
            [ngClass]="{
              'is-invalid': f.submitted && refFI_DoneOn.invalid,
              'alert-warning':
                refFI_DoneOn.invalid &&
                (refFI_DoneOn.dirty ||
                  refFI_DoneOn.touched ||
                  refFI_DoneOn.untouched)
            }"
            class="form-control input-text-css"
            [max]="CurrentDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
        <ng-template #editModeFIDoneOn>
          <span class="form-control input-text-css"
            >{{ FI_DoneOn | date : "dd/MM/yyyy" }}
          </span>
        </ng-template>
      </div>

      <div class="col-md-8 p-1">
        <span class="required-lable">Remarks</span>
        <div *ngIf="!IsEdit; else editModeRemarks">
          <textarea
            name="Remarks"
            id="Remarks"
            class="form-control input-text-css"
            required
            #refRemarks="ngModel"
            [(ngModel)]="Remarks"
            placeholder="Remarks"
            rows="1"
            [ngClass]="{
              'is-invalid': f.submitted && refRemarks.invalid,
              'alert-warning':
                refRemarks.invalid &&
                (refRemarks.dirty || refRemarks.touched || refRemarks.untouched)
            }"
          ></textarea>
        </div>
        <ng-template #editModeRemarks>
          <span class="form-control input-text-css"> {{ Remarks }} </span>
        </ng-template>
      </div>
      <div class="text-right" [ngClass]="'col-md-2'">
        <button
          type="button"
          (click)="onEditCustomerFIAnswer()"
          *ngIf="
            IsEdit &&
            PageAcess &&
            PageAcess[0].Edit == 1 &&
            !loanSummary.CloseDate
          "
          class="mt-3 btn font-size-12 button-btn"
        >
          Edit Answer
        </button>
        <button
          type="button"
          (click)="onSaveCustomerFIAnswer()"
          *ngIf="IsSave && PageAcess[0].Add == 1 && !loanSummary.CloseDate"
          class="mt-3 btn font-size-12 button-btn"
          [class.spinner]="loading"
          [disabled]="!f.form.valid"
        >
          Save Answer
        </button>
        <button
          type="button"
          (click)="onSaveCustomerFIAnswer()"
          *ngIf="IsUpdate && PageAcess[0].Add == 1"
          class="mt-3 btn font-size-12 button-btn"
          [class.spinner]="loading"
          [disabled]="!f.form.valid"
          mat-raised-button
        >
          Update Answer
        </button>
      </div>
    </div>
  </form>
</div>

<div class="row col-md-12 m-0 mt-2 justify-content-end">
  <button
    type="button"
    (click)="onNext()"
    class="mt-3 btn font-size-12 button-btn"
  >
    Next <i class="fa fa-arrow-right"></i>
  </button>
</div>
